import { useMemo } from 'react';
import { computeDistanceBetween } from 'spherical-geometry-js';
import { isResourcePartiallyLoaded } from '~/_shared/types/fetchableResource/fetchableResource.helpers';
import { usePlacesSearchResultsSelector } from '~/store/frontendState/places/places.selectors';
import { useMapSettingsPlacesSearchesSelector } from '~/store/mapSettings/places/mapSettingsPlaces.selectors';

export const usePlacesSearchResults = () => {
  const placesSearchResults = usePlacesSearchResultsSelector();
  const placesSearches = useMapSettingsPlacesSearchesSelector();

  return useMemo(() => {
    const removedPlacesBySearchId = new Map(
      placesSearches.map(search => [search.id, new Set(search.removedPlaces ?? [])])
    );

    const result = new Map(placesSearchResults);

    for (const [searchId, fetchableResult] of result) {
      const search = placesSearches.find(s => s.id === searchId);
      if (!isResourcePartiallyLoaded(fetchableResult) || !search) {
        continue;
      }

      const removedPlaces = removedPlacesBySearchId.get(searchId);

      const filteredItems = removedPlaces?.size
        ? fetchableResult.value.items.filter(place => !removedPlaces.has(place.id))
        : fetchableResult.value.items;

      result.set(searchId, {
        ...fetchableResult,
        value: {
          ...fetchableResult.value,
          items: filteredItems.toSorted((a, b) =>
            computeDistanceBetween(search.center.latLng, a.location)
            - computeDistanceBetween(search.center.latLng, b.location)
          ),
        },
      });
    }

    return result;
  }, [placesSearchResults, placesSearches]);
};
